import { IPurchaseState, IPurchaseStateWithCustomerRelationship } from "@smartrr/shared/entities/PurchaseState";
import { createInteractiveTable } from "@vendor-app/app/_sharedComponents/InteractiveDataTable";
import { HomeTableColumns } from "./columns";
import { HomeTableSorts } from "./sorts";
import { generateQueryFromStore } from "./query";
import { HomeTableFilters } from "./filters";
import { getCustomerPurchaseStates } from "@vendor-app/app/_state/actionCreators/customerPurchaseState";
const initialData: IPurchaseStateWithCustomerRelationship[] = [];

interface HomeTablePersistType {
  selectedColumns: HomeTableColumns.SelectedColumn[];
  selectedSort: HomeTableSorts.SelectedSort;
}

const CURRENT_STORAGE_VERSION = 0;

export const HomeTableAccess = createInteractiveTable<
  IPurchaseState,
  HomeTableFilters.SelectedFilter,
  HomeTableColumns.SelectedColumn,
  HomeTableSorts.SelectedSort,
  HomeTablePersistType
>({
  initialData,
  initialFilters: [],
  initialSorts: [...HomeTableSorts.types],
  initialPagination: {
    pageNumber: 1,
    maxPages: 1,
  },
  initialSelectedFilters: [],
  initialSelectedSort: {
    sortType: "upcomingOrderDate",
    value: "ASC",
  },
  initialSelectedColumns: HomeTableColumns.allColumnTypes.map(c => ({
    columnType: c,
    value: true,
  })),
  async onUpdateTable(currentData, selectedFilters, selectedSort, pagination) {
    const query = generateQueryFromStore(selectedFilters, selectedSort, pagination);

    const response = await getCustomerPurchaseStates({ queryParams: query });

    if (response.type === "success") {
      return {
        data: response.body.data,
        maxPages: response.body.totalPages,
      };
    }

    return {
      data: [],
      maxPages: 0,
    };
  },
  persistSettings: {
    name: "smartrr-home-table-settings",
    version: CURRENT_STORAGE_VERSION,
    partialize(store) {
      const allColumns = HomeTableColumns.allColumnTypes.map(c => {
        const existingColumn = store.selectedColumns.find(col => col.columnType === c);
        // If the column exists in store, use its value, otherwise default to true
        return {
          columnType: c,
          value: existingColumn ? existingColumn.value : true,
        };
      });

      return {
        selectedColumns: allColumns,
        selectedSort: store.selectedSort,
      };
    },
    migrate(storedState, version) {
      if (version === CURRENT_STORAGE_VERSION) {
        return storedState as HomeTablePersistType;
      }
    },
  },
});
